module.exports = __webpack_public_path__ + "static/media/15wkndvsnike.a128e7b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15wkndvsnike.png
// module id = 114
// module chunks = 0